import { defineComponent as _defineComponent } from 'vue';
import { ModalWidthSize } from '@/types/enums';
import { EXIT } from '@/constants/icons';
import { StoreImageDisplay } from '@/components';
export default /*#__PURE__*/_defineComponent({
  __name: 'card',
  props: {
    headerText: {
      default: ''
    },
    headerIcon: {
      default: ''
    },
    headerImageSrc: {
      default: ''
    },
    appendHeaderIcon: {
      default: ''
    },
    background: {
      default: 'layer'
    },
    scrollableContent: {
      default: () => {
        return {
          scrollable: false,
          contentHeight: ''
        };
      }
    },
    closable: {
      type: Boolean,
      default: false
    },
    size: {
      default: ModalWidthSize.MD
    },
    iconColor: {
      default: ''
    },
    headerIconIsButton: {
      type: Boolean,
      default: false
    },
    headerAvatar: {
      default: ''
    },
    headerAvatarText: {
      default: ''
    },
    headerTextBold: {
      type: Boolean,
      default: false
    },
    headerTooltipProps: {
      default: () => {
        return {
          position: 'bottom',
          text: '',
          activatorClass: 'flex-1',
          disabled: true
        };
      }
    },
    counterChip: {
      default: ''
    },
    counterChipState: {
      default: 'background-secondary'
    },
    icon: {
      default: ''
    },
    iconText: {
      default: ''
    }
  },
  emits: ['click:prepend', 'click:append', 'close-card'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const getWidth = () => {
      if (props.size === ModalWidthSize.LG) {
        return '800px';
      } else if (props.size === ModalWidthSize.NONE) {
        return '';
      } else if (props.size === ModalWidthSize.MD) {
        return '468px';
      } else if (props.size === ModalWidthSize.XL) {
        return '1400px';
      } else {
        return '380px';
      }
    };
    const validateFooterContent = scopedSlot => {
      var _scopedSlot$, _scopedSlot$$tag, _scopedSlot$2, _scopedSlot$2$tag;
      if (!scopedSlot) return false;
      if (!((_scopedSlot$ = scopedSlot()[0]) !== null && _scopedSlot$ !== void 0 && (_scopedSlot$$tag = _scopedSlot$.tag) !== null && _scopedSlot$$tag !== void 0 && _scopedSlot$$tag.includes('UcButtonGroup')) && !((_scopedSlot$2 = scopedSlot()[0]) !== null && _scopedSlot$2 !== void 0 && (_scopedSlot$2$tag = _scopedSlot$2.tag) !== null && _scopedSlot$2$tag !== void 0 && _scopedSlot$2$tag.includes('UcModalFooter'))) {
        throw new TypeError('you must use the uc-button-group component in the footer');
      }
      return true;
    };
    return {
      __sfc: true,
      props,
      emit,
      getWidth,
      validateFooterContent,
      EXIT,
      StoreImageDisplay
    };
  }
});